{
  "city-card": {
    "text": {
      "explore-top-salons": "Explore top salons in"
    }
  }
}
